module.exports = {"411202001":"湖滨街道","411202002":"前进街道","411202003":"车站街道","411202004":"涧河街道","411202005":"大安街道","411202006":"会兴街道","411202007":"崖底街道","411202201":"交口乡","411202202":"磁钟乡","411202203":"高庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411202.json
// module id = 1489
// module chunks = 0